var paramsIndex = {
    title: 0,
    description: 1,
    list: 2,
    limit: 3,
    defer: 'defer'
};
var TransferData = /** @class */ (function () {
    function TransferData() {
    }
    TransferData.prototype.setArguments = function (args) {
        this.args = args;
    };
    TransferData.prototype.getArguments = function (key) {
        return this.args[paramsIndex[key]];
    };
    return TransferData;
}());
export default TransferData;
